<template>
  <div class="content-table">
    <el-form :inline="true" :model="formData" class="demo-form-inline">
      <el-form-item label="订单号:">
        <el-input v-model="formData.orderNo" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="确认号:">
        <el-input v-model="formData.confirmNo" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="下单日期:">
        <el-date-picker
          v-model="formData.createTime"
          type="date"
          placeholder=""
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="取消日期:">
        <el-date-picker
          v-model="formData.cancelTime"
          type="date"
          placeholder=""
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="getList">搜索</el-button>
        <el-button type="info" size="mini" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <div class="table-nav flex-center">
        <div
          class="nav-item cursor"
          v-for="(item,index) in tabelNav"
          :key="index"
          :class="{'nav-item-active':item.statu}"
          @click="getNavList(item,index)"
        >{{item.text}}</div>
      </div>
      <el-table ref="multipleTable" :data="tableData" style="width: 100%">
        <!-- <el-table-column
                                type="selection"
                                width="55">
        </el-table-column>-->
        <el-table-column label="" align="center" width="100">
          <template slot-scope="scope">
            <img :src="scope.row.imageUrl || img" alt="" class="table-img">
          </template>
        </el-table-column>
        <el-table-column label="订单内容" align="center" width="150">
          <template slot-scope="scope">
            <p class="table-title">{{scope.row.hotelNameCn}}</p>
            <p class="table-title">{{scope.row.breakfastTypeName}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="订单编号" align="center">
          <template slot-scope="scope">
            <span class="font-13">{{scope.row.orderNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="确认号" align="center">
          <template slot-scope="scope">
            <span class="font-13">{{scope.row.confirmNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="预定时间" width="150">
          <template slot-scope="scope">
            <p class="font-12">入住时间：{{scope.row.checkInDate}}</p>
            <p class="font-12">离店时间：{{scope.row.checkOutDate}}</p>
          </template>
        </el-table-column>
        <el-table-column label="下单日期" align="center" width="150">
          <template slot-scope="scope">{{scope.row.createTime}}</template>
        </el-table-column>
        <el-table-column label="取消日期" align="center" width="150">
          <template slot-scope="scope">{{scope.row.cancelTime}}</template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="总金额">
          <template slot-scope="scope">
            <span class="table-money">
              <i>¥</i>
              {{scope.row.orderAmount}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="订单状态">
          <template slot-scope="scope">
            <span class="font-12">{{scope.row.cancelStatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="80">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="goInfo(scope.row)">查看订单</el-button>
            </div>
            <!-- <div><el-button  type="text" size="small" @click="cancelOrder">取消订单</el-button></div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageing flex-end">
      <el-pagination
        @current-change="handleCurrentChange"
        background=""
        :page-size="formData.pageSize"
        :current-page="formData.currentPage"
        layout="prev, pager, next, jumper"
        :total="totalPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { queryHotelCancelOrderList } from "@/lib/data-service/hotel";
import scrollTop from "@/lib/common-service/scrollTop";
import { STATUS } from "@/lib/deprecated/utils/status";
const SUCCESS_CODE = STATUS.success;
export default {
  data() {
    return {
      formData: {
        pageSize: 10,
        currentPage: 1,
        cancelStatus: "-1"
      },
      totalPage: 0,
      value1: "",
      tabelNav: [
        { text: "全部订单", statu: true, val: "-1" },
        // {text:'待支付',statu:false,val:0},
        // {text:'支付中',statu:false,val:1},
        // {text:'待确认',statu:false,val:2},
        // {text:'已确认',statu:false,val:3},
        // {text:'已拒单',statu:false,val:4},
        // {text:'已取消',statu:false,val:5},
        { text: "申请取消", statu: false, val: 0 },
        { text: "取消成功", statu: false, val: 1 },
        { text: "待平台确认", statu: false, val: 2 },
        { text: "取消失败", statu: false, val: 3 }
      ],
      tableData: [],
      cancelText: "",
      img: `../https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/src/assets/hotel.jpg`
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //表格类型搜索
    getNavList(val, index) {
      let data = this.formData;
      this.tabelNav.map(item => {
        item.statu = false;
      });
      this.$nextTick(() => {
        this.tabelNav[index].statu = true;
      });
      data.cancelStatus = val.val;
      this.formData.currentPage = 1;
      this.getList();
    },
    reset() {
      this.formData = {
        pageSize: 10,
        currentPage: 1
      };
    },
    //表格选择
    handleSelectionChange(val) {
      console.log(val);
    },
    //分页
    handleCurrentChange(val) {
      this.formData.currentPage = val;
      this.getList();
    },
    //获取订单列表
    getList() {
      let data = Object.assign({}, this.formData);
      data.createTime = data.createTime ? data.createTime : "";
      data.cancelTime = data.cancelTime ? data.cancelTime : "";
      queryHotelCancelOrderList(data).then(res => {
        // console.log(res)
        if (res.code === SUCCESS_CODE) {
          scrollTop(500);
          this.tableData = res.pageResult.pageData;
          this.totalPage = res.pageResult.totalCount;
        }
      });
    },
    //查看订单
    goInfo(val) {
      this.$router.push({
        path: "hotel-manage-order-info",
        query: { orderNo: val.orderNo, type: "cancel" }
      });
    },
    //取消订单
    cancelOrder(val) {
      // console.log(val)
      let data = {
        orderNo: val.orderNo
      };
      this.$prompt("请输入取消原因：", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          if (!value)
            return this.$message({
              type: "warning",
              message: "请填写取消原因"
            });
          data.cancelRemark = value;
          cancelOrderSubmit(data).then(res => {
            if (res.code === SUCCESS_CODE) {
              this.$message({ type: "success", message: "取消订单成功" });
              this.getList();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.content-table {
  border-top: 3px solid #237dc9;
  /deep/.el-button {
    border-radius: 0;
  }
  .table-nav {
    justify-content: flex-start;
    padding: 0 10px;
    background: #f1f4fb;
    color: #7c7d7d;
    font-size: 14px;
    margin-top: 10px;
    .nav-item {
      padding: 8px 20px;
      &:hover {
        color: #237dc9;
      }
    }
  }
  .demo-form-inline {
    height: 60px;
    padding: 0 10px;
    display: flex;
    background: #f4f9ff;
    align-items: center;
    justify-content: space-between;
    .el-form-item {
      margin-bottom: 0;
    }
    /deep/.el-input {
      input {
        height: 30px;
        border-radius: 0;
        width: 140px;
      }
    }
    .el-date-editor {
      width: 140px;
    }
  }
}
.table-img {
  width: 100%;
  height: 50px;
}
.table-title {
  color: #237dc8;
  font-size: 15px;
}
.table-money {
  font-size: 13px;
  color: #ff6600;
  i {
    font-size: 12px;
    font-style: normal;
  }
}
.pageing {
  margin-top: 10px;
}
.nav-item-active {
  color: #237dc9;
  background: white;
  border-top: 3px solid #237dc9;
}
</style>
